import request from '@/utils/request'

/**
 * 通过code换取网页授权access_token
 * @param {*} code 填写第一步获取的code参数
 */
export function getAccessToken(code) {
  return request({
    url: '/Wechat/GetAccessToken',
    method: 'get',
    params: { code }
  })
}



// WEBPACK FOOTER //
// ./src/api/wechat.js